//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import {
  EmailSignupCountResponse,
  UnifiedMetricsBubbleStatsResponse,
  UnifiedMetricsGraphStatsResponse,
  UnifiedMetricsTouchpointStatsResponse,
} from '@bvengineering/metrics-gateway-service-types';

import {
  IContentAcquisitionResponse,
  IStatsRequest,
  SortDirection,
  SortKey,
  UnifiedMetricsItemProductStatsResponseContributorInfo,
  UnifiedMetricsItemProductStatsResponseItemInfo,
  UnifiedMetricsItemProductStatsResponseProductInfo,
} from '@apis/metrics/metricsApiModel';
import {
  TopPerformersContentType,
  TopPerformersTableView,
} from '@insights/insightsConstants';
import { ILabel } from '@models/ILabel';

import { IContentItemDetails } from 'app/bulk-actions/model/AppState';

export interface IInsightsPage {
  statsRequestBase?: IStatsRequest;
  bubbleStats?: IInsightsBubbleStats;
  graphStats?: IInsightsGraphStats;
  activityStats: IInsightsActivityStats;
  allLabels?: ILabel[];
  flags: {
    isFetchingBubbleStats: boolean;
    isFetchingGraphStats: boolean;
    isFetchingActivityStats: boolean;
    isFetchingLabels: boolean;
  };
  errors: {
    fetchBubbleStatsError?: string;
    fetchGraphStatsError?: string;
    fetchActivityStatsError?: string;
    fetchLabelsError?: string;
  };
}

export interface IInsightsBubbleStats {
  stats?: UnifiedMetricsBubbleStatsResponse;
  emailSignups?: EmailSignupCountResponse;
  isEmailSignupsEnabled?: boolean;
}

export const EMPTY_UNIFIED_METRICS_BUBBLE_STATS_RESPONSE = {
  visits: 0,
  interactions: 0,
  clicks: 0,
  transactions: 0,
  revenue: 0,
  ecomSessions: 0,
};

export interface IUnifiedMetricsGraphStatsResponse
  extends UnifiedMetricsGraphStatsResponse {
  label?: string;
}

export interface IInsightsGraphStats {
  stats: IUnifiedMetricsGraphStatsResponse[];
}

export interface IInsightsActivityStats {
  contentType: TopPerformersContentType;
  view: TopPerformersTableView;
  sortKey: SortKey;
  sortDir: SortDirection;
  limit: number;
  offset: number;
  itemStats?: TopPerformersItemProductStat[];
}

export interface TopPerformersItemProductStat {
  stats:
    | UnifiedMetricsItemProductStatsResponseItemInfo
    | UnifiedMetricsItemProductStatsResponseProductInfo
    | UnifiedMetricsItemProductStatsResponseContributorInfo;
  details?: IContentItemDetails;
}

export interface IInsightsExperienceStats {
  stats: UnifiedMetricsTouchpointStatsResponse[];
}

export interface IInsightsContentAcquisitionStats {
  stats: IContentAcquisitionResponse;
}
